export const PROPERTY_REQUEST = "PROPERTY_REQUEST";
